import React from 'react';
import Video from './Video';
import Image from './Image';

export default function Media({ videoSrc, image, className, mediaType }) {
  return (
    <>
      {image && !videoSrc && <Image mediaSrc={image.asset.url} className={className} />}
      {videoSrc && <Video mediaSrc={videoSrc} className={className} mediaType={mediaType} />}
    </>
  );
}
